import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {
  has_primary_media: 'has_primary_media',
  has_no_primary_media: 'has_no_primary_media',
};
export default {
  crawlType: 'feature_grid_media',
  matchTemplates: [
    {
      type: sectionType.sectionCardSatelliteRivoneed,
      tags: [IDENTIFIER_TAGS.has_primary_media],
      priority: 1,
    },
    {
      type: sectionType.sectionTinoGrid,
      tags: [IDENTIFIER_TAGS.has_no_primary_media],
      priority: 2,
    },
  ],
};
